// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","borderRed":"#ffb9b9","customWhite":"#ffffff","container":"_3IDNYRDA9Dut0drj1Xs6nt _2lYHSCAcM6vA2s-47YYZeS","closeIcon":"VCVJXyO-ihkkzXVhD7qOF","line":"_3TUfpHggZziY8aSRmaQlt6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/alert/Alert.css
// module id = 928
// module chunks = 1